import { useEffect, useRef, useState } from 'react'

/**
 * Mounts children only after the placeholder enters (or nears) the viewport.
 * Reduces main-thread + network work until the user scrolls toward below-the-fold UI.
 */
export function DeferNearViewport({ children, className = '', minHeight = 0, rootMargin = '200px' }) {
  const ref = useRef(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (show) return undefined
    const fallback = window.setTimeout(() => setShow(true), 8000)
    if (typeof IntersectionObserver === 'undefined') {
      setShow(true)
      return () => window.clearTimeout(fallback)
    }
    const el = ref.current
    if (!el) {
      window.clearTimeout(fallback)
      return undefined
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setShow(true)
          io.disconnect()
        }
      },
      { rootMargin, threshold: 0.01 },
    )
    io.observe(el)
    return () => {
      window.clearTimeout(fallback)
      io.disconnect()
    }
  }, [show, rootMargin])

  return (
    <div ref={ref} className={className} style={!show && minHeight ? { minHeight } : undefined}>
      {show ? children : null}
    </div>
  )
}
